import type { Transaction } from '@atlaskit/editor-prosemirror/state';
import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import { SafePlugin } from '@atlaskit/editor-common/safe-plugin';
import { isFedRamp } from '@atlaskit/atlassian-context';

import type { StepsDatabase } from '../stepsDatabase';

export type EditorOfflineStoragePluginStatus = 'pending' | 'restoring' | 'ready' | 'tooManyRetries';

export type EditorOfflineStorageDisabledReason =
	| 'disabledEnvironment'
	| 'stepsDatabaseError'
	| 'tooManyRetries'
	| 'unableToSync';

export type EditorOfflineStoragePluginState = {
	status: EditorOfflineStoragePluginStatus;
	retryCount: number;
	disabled: EditorOfflineStorageDisabledReason | false;
	disableEditor: boolean;
};

export const editorOfflineStoragePluginKey = new PluginKey<EditorOfflineStoragePluginState>(
	'editorOfflineStoragePlugin',
);

export const createPlugin = (stepsDatabase: StepsDatabase) => () => {
	return new SafePlugin<EditorOfflineStoragePluginState>({
		key: editorOfflineStoragePluginKey,
		state: {
			init() {
				return {
					status: 'pending',
					retryCount: 0,
					disabled: isFedRamp() ? 'disabledEnvironment' : false,
					disableEditor: false,
				};
			},
			apply: (tr: Transaction, currentPluginState: EditorOfflineStoragePluginState) => {
				const meta = tr.getMeta(editorOfflineStoragePluginKey);
				if (meta) {
					return {
						...currentPluginState,
						...meta,
					};
				}
				return currentPluginState;
			},
		},
		view: () => {
			return {
				destroy() {
					return stepsDatabase.closeDB();
				},
			};
		},
	});
};
